import { render, staticRenderFns } from "./ValidationErrorAlert.vue?vue&type=template&id=63d8b9d3&scoped=true&"
import script from "./ValidationErrorAlert.vue?vue&type=script&lang=js&"
export * from "./ValidationErrorAlert.vue?vue&type=script&lang=js&"
import style0 from "./ValidationErrorAlert.vue?vue&type=style&index=0&id=63d8b9d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d8b9d3",
  null
  
)

export default component.exports